import { Flex, Typography } from "antd"

export const PaymentsLinkStepUi = () => {
  return (
    <Flex vertical>
      <Typography.Text>
        You can send payment links to your customers or partners via email or
        messengers.
      </Typography.Text>

      <ul>
        <li>
          A payment link can have either a limited or unlimited expiration
          period.
        </li>
        <li>
          After creating the link, simply copy and share it in any way that
          suits you.
        </li>
      </ul>
    </Flex>
  )
}
